import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from '@pkg/hooks';

import { handleSearchEmojis } from '@app/store/zustand/useEmojisStore.ts';

const EMOJI_DETAILS_KEY = 'EMOJI_DETAILS_KEY';

export function useEmojiDetailsQuery() {
    const primaryYat = useAppSelector((state) => state.yatPage.eid);

    const { isLoading, data: emojiData } = useQuery({
        queryKey: [EMOJI_DETAILS_KEY, primaryYat],
        queryFn: () => handleSearchEmojis(primaryYat || ''),
        enabled: !!primaryYat,
        select: (res) => {
            if (res.ok && res.value) return res.value.result;
        },
    });

    return {
        generation: emojiData?.generation,
        score: emojiData?.rhythm_score || 0,
        modalContent: {
            description: emojiData?.copy.description || '',
            features: emojiData?.copy.features || [],
        },
        isLoading,
    };
}
